import React, {useEffect, useRef, useState} from "react";

import HeroSection from "./sections/hero";
import MultimodalSection from "./sections/multimodal";
import CrossDockingSection from "./sections/cross-docking";
import TariffsSection from "./sections/tariffs";
import PlatformCapabilitiesSection from "./sections/platform-capabilities";
import RoutesMapSection from "./sections/routes-map";
import GettingStartedSection from "./sections/getting-started";
import FaqSection from "./sections/faq";
import {featuredNewsItems} from "./content/featured-news";
import {
    prefersReducedMotion,
} from "../../../presentation/public-site/motion-preference";
import "./style.less";
import "./landing-shared.less";

function canRevealLandingSections() {
    if (
        typeof window === "undefined" ||
        !("IntersectionObserver" in window)
    ) {
        return false;
    }

    return !prefersReducedMotion();
}

export default function MainPage() {
    const landingPageRef = useRef(null);
    const [sectionRevealEnabled] = useState(
        canRevealLandingSections
    );

    useEffect(() => {
        if (
            !sectionRevealEnabled ||
            !landingPageRef.current
        ) {
            return undefined;
        }

        const sections = Array.from(
            landingPageRef.current.children
        ).filter(
            (element) =>
                element.tagName === "SECTION" &&
                !element.classList.contains(
                    "landing-hero"
                )
        );

        const observer =
            new window.IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) {
                            return;
                        }

                        entry.target.classList.add(
                            "landing-section--visible"
                        );

                        observer.unobserve(
                            entry.target
                        );
                    });
                },
                {
                    threshold: 0.12,
                    rootMargin:
                        "0px 0px -8% 0px",
                }
            );

        sections.forEach((section) => {
            observer.observe(section);
        });

        return () => {
            observer.disconnect();
        };
    }, [sectionRevealEnabled]);

    return (
        <main
            ref={landingPageRef}
            className={`content landing-page${
                sectionRevealEnabled
                    ? " landing-page--section-reveal"
                    : ""
            }`}
        >
            <HeroSection
                newsItems={featuredNewsItems}
            />

            <PlatformCapabilitiesSection/>
            <MultimodalSection/>
            <CrossDockingSection/>
            <RoutesMapSection/>
            <TariffsSection/>
            <GettingStartedSection/>
            <FaqSection/>
        </main>
    );
}
